import EntityStatusFilterTabs from '../../../components/shared/EntityStatusFilterTabs';

type AcquirerFiltersProps = {
  filterStatus: string;
  onFilterStatusChange: (value: string) => void;
  loading: boolean;
  statsAcquirers: { status?: string | null }[];
};

export default function AcquirerFilters({
  filterStatus,
  onFilterStatusChange,
  loading,
  statsAcquirers,
}: AcquirerFiltersProps) {
  return (
    <EntityStatusFilterTabs
      filterStatus={filterStatus}
      onFilterStatusChange={onFilterStatusChange}
      loading={loading}
      items={statsAcquirers}
      ariaLabel="Acquirer status"
    />
  );
}
